<template lang='pug'>
.fpui-monitoring-console-service
  fpui-modal-header(:title="label | translate", @close='$emit("close")')
  fpui-modal-body
    fpui-tabs
      fpui-tab(:header='pod.display_name', v-for='pod, idx in pods', :key='idx')
        monitoring-logs-tab(:value='pod', :fpapi='fpapi')
</template>

<script>
import MonitoringLogsTab from './MonitoringLogsTab'

export default {
  components: { MonitoringLogsTab },
  props: {
    label: String,
    services: Object,
    activeTab: { type: Number, default: 0 },
    fpapi: { type: Object, required: true }
  },
  computed: {
    pods () {
      let pods = []
      Object.keys(this.services).forEach(key => {
        this.services[key].instances.forEach((instance, index) => {
          let toPush = {...instance}
          toPush.display_name = key
          if (this.services[key].instances.length > 1) toPush.display_name += '-' + (index + 1)
          if (!this.services[key].running) instance.state = 'Error'
          pods.push(toPush)
        })
      })
      return pods
    }
  }
}
</script>

<style lang='less'>
  .fpui-monitoring-console-service {
  }
</style>
